import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {empty, EMPTY, Observable, of} from "rxjs";
import {AppointmentService} from "../services/appointment.service";
import {catchError, switchMap} from "rxjs/operators";
import {AppointmentModel} from "../../core/models/appointment.model";
import {TimeSlotsModel} from "../../core/models/time-slots.model";
import {UrlTreeHelper} from "../../core/services/url-tree-helper";
import {TimeSlotModel} from "../../core/models/time-slot.model";

@Injectable()
export class TimeSlotResolverGuard implements Resolve<any> {
  constructor(
    private appointmentService: AppointmentService,
    private router: Router,
    private urlTreeHelper: UrlTreeHelper,
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    console.log("Resolving TimeSlots for " + route.params['id']);
    const BASE_PATH = '/' + route.params['factoryId'] + '/' + route.params['language'] + '/' + route.params['id'];
    return this.appointmentService.getTimeSlots(route.params['id']).pipe(
      switchMap((data: TimeSlotsModel) => {
        if (data == null) {
          this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
            BASE_PATH, { suffix: '/proposal/declined-no-timeslot-lookup'}));
          return of({items: [], itemsFound: false, error: 'Error fetching TimeSlots'});
        }
        if (data && !data.itemsFound) {
          this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
            BASE_PATH, { suffix: '/proposal/declined-timeslot-lookup-no-results'}));
        }
        return of(data);
      }),
      catchError((error) => {
        console.error('Error fetching TimeSlots:', error);
        this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
          BASE_PATH, { suffix: '/proposal/declined-timeslot-lookup-no-results'}));
        return of({items: [], itemsFound: false, error: 'Error fetching TimeSlots'});
      })
    );
  }
}
